import React, { useState } from 'react';
import { ScrollView } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Group } from 'src/components/Group';
import { Switch } from 'src/components/Switch';
import { Avatar } from 'src/components/Avatar';
import ProfileIcon from 'src/assets/icons/user.svg';
import BellIcon from 'src/assets/icons/bell.svg';
import GlobeIcon from 'src/assets/icons/globe.svg';
import SettingsIcon from 'src/assets/icons/settings.svg';
import PhoneIcon from 'src/assets/icons/phone-call.svg';
import MessagesIcon from 'src/assets/icons/message-square.svg';
import MoreHorizontalIcon from 'src/assets/icons/more-horizontal.svg';
import { Cell, CellIcon, CellButton } from 'src/components/Cell';
import { Separator } from 'src/components/Separator';

let CellExample = () => {
  const [checkedLang, checkLang] = useState('ru');

  return (
    <ScrollView>
      <PanelHeader separator={<Separator line />}>🧱 Cell</PanelHeader>
      <Group>
        <Cell
          before={
            <CellIcon>
              <ProfileIcon />
            </CellIcon>
          }
          expandable
        >
          Profile
        </Cell>
        <Cell
          before={
            <CellIcon>
              <BellIcon />
            </CellIcon>
          }
          expandable
        >
          Notifications
        </Cell>
        <Cell
          before={
            <CellIcon>
              <SettingsIcon />
            </CellIcon>
          }
          expandable
        >
          Preferences
        </Cell>
      </Group>
      <Group>
        <Cell
          before={
            <CellIcon>
              <PhoneIcon />
            </CellIcon>
          }
          indicator="+7 964 144 66 11"
          expandable
        >
          Phone Number
        </Cell>
        <Cell
          before={
            <CellIcon>
              <GlobeIcon />
            </CellIcon>
          }
          indicator="Russian"
          expandable
        >
          Interface language
        </Cell>
      </Group>
      <Group>
        <Cell indicator="US English" expandable>
          Language
        </Cell>
        <Cell indicator="While using" expandable>
          Geolocation
        </Cell>
      </Group>
      <Group>
        <Cell name="ru" checked={checkedLang === 'ru'} onChange={checkLang}>
          Russian
        </Cell>
        <Cell name="en" checked={checkedLang === 'en'} onChange={checkLang}>
          English
        </Cell>
      </Group>
      <Group>
        <Cell after={<Switch value={true} />} disabled>
          Push Notifications
        </Cell>
        <Cell after={<Switch value={true} />} disabled>
          Email Digest
        </Cell>
      </Group>
      <Group separator={false}>
        <Cell
          before={<Avatar name="John Doe" source={{ uri: 'https://unsplash.it/100' }} />}
          after={
            <CellButton>
              <CellIcon>
                <MessagesIcon />
              </CellIcon>
            </CellButton>
          }
        >
          John Doe
        </Cell>
        <Cell
          before={<Avatar name="Robert Downey Jr." />}
          after={
            <CellButton>
              <CellIcon>
                <MoreHorizontalIcon />
              </CellIcon>
            </CellButton>
          }
        >
          Robert Downey Jr.
        </Cell>
      </Group>
    </ScrollView>
  );
};

storiesOf('Cell', module).add('Default', () => <CellExample />);
